import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';

const CONTACT_US_STEPS = {
  AKC: 'akc',
  FIGO: 'figo',
  HOME: 'home',
  PPI: 'ppi',
  PPI_ONE_PACK: 'ppiOnePack',
  PPU: 'ppu',
  PPU_PET_CARE: 'ppuPetCare',
  SPOT: 'spot',
};

const CONTACT_US_STEPS_BY_NUMBER = {
  0: 'home',
  1: 'figo',
  2: 'ppi',
  3: 'akc',
  4: 'ppiOnePack',
  5: 'ppuPetCare',
  6: 'spot',
};

const CONTACT_US_PROVIDERS = [
  { id: MARKETING_CHANNEL_ID.akc, name: 'American Kennel Club' },
  { id: MARKETING_CHANNEL_ID.figo, name: 'Figo Pet Insurance' },
  { id: MARKETING_CHANNEL_ID.ppi, name: 'Pet Partners' },
  { id: MARKETING_CHANNEL_ID.ppiG, name: 'One Pack' },
  { id: MARKETING_CHANNEL_ID.ppu, name: 'Pets Plus Us' },
  { id: MARKETING_CHANNEL_ID.ppuPetCare, name: 'Pets Plus Us' },
  // not official support for spot us yet, so spot canada is the only one.
  // For contentful exists spot and spot...
  { id: MARKETING_CHANNEL_ID.spotCan, name: 'Spot' },
];

const MESSENGER_LINK = 'http://m.me/FigoPet';

const FACEBOOK_TITLE = 'Facebook';

export {
  CONTACT_US_PROVIDERS,
  CONTACT_US_STEPS_BY_NUMBER,
  CONTACT_US_STEPS,
  FACEBOOK_TITLE,
  MESSENGER_LINK,
};
